/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCorporationsCorporationIdBookmarksCoordinates } from './GetCorporationsCorporationIdBookmarksCoordinates';
import {
    GetCorporationsCorporationIdBookmarksCoordinatesFromJSON,
    GetCorporationsCorporationIdBookmarksCoordinatesFromJSONTyped,
    GetCorporationsCorporationIdBookmarksCoordinatesToJSON,
    GetCorporationsCorporationIdBookmarksCoordinatesToJSONTyped,
} from './GetCorporationsCorporationIdBookmarksCoordinates';
import type { GetCorporationsCorporationIdBookmarksItem } from './GetCorporationsCorporationIdBookmarksItem';
import {
    GetCorporationsCorporationIdBookmarksItemFromJSON,
    GetCorporationsCorporationIdBookmarksItemFromJSONTyped,
    GetCorporationsCorporationIdBookmarksItemToJSON,
    GetCorporationsCorporationIdBookmarksItemToJSONTyped,
} from './GetCorporationsCorporationIdBookmarksItem';

/**
 * 200 ok object
 * @export
 * @interface GetCorporationsCorporationIdBookmarks200Ok
 */
export interface GetCorporationsCorporationIdBookmarks200Ok {
    /**
     * bookmark_id integer
     * @type {number}
     * @memberof GetCorporationsCorporationIdBookmarks200Ok
     */
    bookmarkId: number;
    /**
     * 
     * @type {GetCorporationsCorporationIdBookmarksCoordinates}
     * @memberof GetCorporationsCorporationIdBookmarks200Ok
     */
    coordinates?: GetCorporationsCorporationIdBookmarksCoordinates;
    /**
     * created string
     * @type {Date}
     * @memberof GetCorporationsCorporationIdBookmarks200Ok
     */
    created: Date;
    /**
     * creator_id integer
     * @type {number}
     * @memberof GetCorporationsCorporationIdBookmarks200Ok
     */
    creatorId: number;
    /**
     * folder_id integer
     * @type {number}
     * @memberof GetCorporationsCorporationIdBookmarks200Ok
     */
    folderId?: number;
    /**
     * 
     * @type {GetCorporationsCorporationIdBookmarksItem}
     * @memberof GetCorporationsCorporationIdBookmarks200Ok
     */
    item?: GetCorporationsCorporationIdBookmarksItem;
    /**
     * label string
     * @type {string}
     * @memberof GetCorporationsCorporationIdBookmarks200Ok
     */
    label: string;
    /**
     * location_id integer
     * @type {number}
     * @memberof GetCorporationsCorporationIdBookmarks200Ok
     */
    locationId: number;
    /**
     * notes string
     * @type {string}
     * @memberof GetCorporationsCorporationIdBookmarks200Ok
     */
    notes: string;
}

/**
 * Check if a given object implements the GetCorporationsCorporationIdBookmarks200Ok interface.
 */
export function instanceOfGetCorporationsCorporationIdBookmarks200Ok(value: object): value is GetCorporationsCorporationIdBookmarks200Ok {
    if (!('bookmarkId' in value) || value['bookmarkId'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('creatorId' in value) || value['creatorId'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('notes' in value) || value['notes'] === undefined) return false;
    return true;
}

export function GetCorporationsCorporationIdBookmarks200OkFromJSON(json: any): GetCorporationsCorporationIdBookmarks200Ok {
    return GetCorporationsCorporationIdBookmarks200OkFromJSONTyped(json, false);
}

export function GetCorporationsCorporationIdBookmarks200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCorporationsCorporationIdBookmarks200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'bookmarkId': json['bookmark_id'],
        'coordinates': json['coordinates'] == null ? undefined : GetCorporationsCorporationIdBookmarksCoordinatesFromJSON(json['coordinates']),
        'created': (new Date(json['created'])),
        'creatorId': json['creator_id'],
        'folderId': json['folder_id'] == null ? undefined : json['folder_id'],
        'item': json['item'] == null ? undefined : GetCorporationsCorporationIdBookmarksItemFromJSON(json['item']),
        'label': json['label'],
        'locationId': json['location_id'],
        'notes': json['notes'],
    };
}

export function GetCorporationsCorporationIdBookmarks200OkToJSON(json: any): GetCorporationsCorporationIdBookmarks200Ok {
    return GetCorporationsCorporationIdBookmarks200OkToJSONTyped(json, false);
}

export function GetCorporationsCorporationIdBookmarks200OkToJSONTyped(value?: GetCorporationsCorporationIdBookmarks200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'bookmark_id': value['bookmarkId'],
        'coordinates': GetCorporationsCorporationIdBookmarksCoordinatesToJSON(value['coordinates']),
        'created': ((value['created']).toISOString()),
        'creator_id': value['creatorId'],
        'folder_id': value['folderId'],
        'item': GetCorporationsCorporationIdBookmarksItemToJSON(value['item']),
        'label': value['label'],
        'location_id': value['locationId'],
        'notes': value['notes'],
    };
}

